//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import propTypes from "prop-types";

//Element
class Item extends Component {
    //Element
    render() {
        //Element
        const { ID, Company, Project, Location, Date } = this.props
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB h12444" },
            //Element
            React.createElement(Row, {},
                //Element
                React.createElement(Col, { md: 3 },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB u013h3" },
                        //Element
                        Company
                    )
                ),
                //Element
                React.createElement(Col, { md: 4 },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB u013h3" },
                        //Element
                        Project
                    )
                ),
                //Element
                React.createElement(Col, { md: 3 },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB u013h3" },
                        //Element
                        Location
                    )
                ),
                //Element
                React.createElement(Col, { md: 5 },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB u013h3" },
                        //Element
                        Date
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
Item.propTypes = {
    ID: propTypes.string.isRequired,
    Company: propTypes.string.isRequired,
    Project: propTypes.string.isRequired,
    Location: propTypes.string.isRequired,
    Date: propTypes.string.isRequired
}
//Element
export default Item;